var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import React from 'react';
// Helper: safely convert any value to string
function safeToString(value) {
    var _a;
    if (value === undefined || value === null)
        return '';
    if (React.isValidElement(value)) {
        var children = (_a = value.props) === null || _a === void 0 ? void 0 : _a.children;
        if (children === undefined || children === null)
            return '';
        if (Array.isArray(children))
            return children.map(safeToString).join(' ');
        return String(children);
    }
    if (typeof value === 'object')
        return JSON.stringify(value);
    return String(value);
}
var SLATE = {
    ink: [15, 23, 42],
    body: [51, 65, 85],
    muted: [100, 116, 139],
    kicker: [148, 163, 184],
    line: [226, 232, 240],
    head: [248, 250, 252],
};
export function exportTableToPDF(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var allData, flatColumns, head, body, doc, margin, pageWidth, align, textX, startY;
        var _c;
        var columns = _b.columns, fetchAllData = _b.fetchAllData, _d = _b.fileName, fileName = _d === void 0 ? 'export.pdf' : _d, kicker = _b.kicker, title = _b.title, meta = _b.meta;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, fetchAllData()];
                case 1:
                    allData = _e.sent();
                    flatColumns = columns.filter(function (col) {
                        return 'dataIndex' in col && col.dataIndex !== undefined;
                    });
                    head = flatColumns.map(function (col) {
                        var label = typeof col.title === 'string' ? col.title : safeToString(col.title);
                        return label.toLocaleUpperCase();
                    });
                    body = allData.map(function (item) {
                        return flatColumns.map(function (col) {
                            var value = col.render
                                ? col.render(item[col.dataIndex], item, 0)
                                : item[col.dataIndex];
                            return safeToString(value);
                        });
                    });
                    doc = new jsPDF({ unit: 'mm', format: 'a4' });
                    margin = 14;
                    pageWidth = doc.internal.pageSize.getWidth();
                    align = ((_c = document === null || document === void 0 ? void 0 : document.documentElement) === null || _c === void 0 ? void 0 : _c.dir) === 'rtl' ? 'right' : 'left';
                    textX = align === 'right' ? pageWidth - margin : margin;
                    startY = margin;
                    if (kicker || title || meta) {
                        if (kicker) {
                            doc.setFont('helvetica', 'bold');
                            doc.setFontSize(8);
                            doc.setTextColor.apply(doc, SLATE.kicker);
                            doc.setCharSpace(0.6);
                            doc.text(kicker.toLocaleUpperCase(), textX, startY + 4, { align: align });
                            doc.setCharSpace(0);
                            startY += 8;
                        }
                        if (title) {
                            doc.setFont('helvetica', 'bold');
                            doc.setFontSize(18);
                            doc.setTextColor.apply(doc, SLATE.ink);
                            doc.text(title, textX, startY + 6, { align: align });
                            startY += 10;
                        }
                        if (meta) {
                            doc.setFont('helvetica', 'normal');
                            doc.setFontSize(9);
                            doc.setTextColor.apply(doc, SLATE.muted);
                            doc.text(meta, textX, startY + 4, { align: align });
                            startY += 8;
                        }
                        doc.setDrawColor.apply(doc, SLATE.line);
                        doc.setLineWidth(0.3);
                        doc.line(margin, startY + 2, pageWidth - margin, startY + 2);
                        startY += 8;
                    }
                    autoTable(doc, {
                        startY: startY,
                        margin: { left: margin, right: margin },
                        head: [head],
                        body: body,
                        theme: 'plain',
                        styles: {
                            font: 'helvetica',
                            fontSize: 9,
                            textColor: SLATE.body,
                            halign: align,
                            cellPadding: { top: 2.8, right: 3, bottom: 2.8, left: 3 },
                            lineColor: SLATE.line,
                            lineWidth: { bottom: 0.2 },
                            fillColor: [255, 255, 255],
                        },
                        headStyles: {
                            fillColor: SLATE.head,
                            textColor: SLATE.muted,
                            fontStyle: 'bold',
                            fontSize: 8,
                            halign: align,
                            lineWidth: { bottom: 0.3 },
                        },
                    });
                    doc.save(fileName);
                    return [2 /*return*/];
            }
        });
    });
}
